module.exports = __webpack_public_path__ + "static/media/img-office-structure@3x.d44f7a7c.png";